var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 -5 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 6.21865C29.8641 4.25754 27.4375 2.73909 24.72 1.66329C21.9191 0.554429 19.0125 0 16 0C12.9876 0 10.0809 0.554429 7.27996 1.66329C4.56255 2.73909 2.13589 4.25754 0 6.21865L2.79503 9.01366C4.54362 7.43582 6.52304 6.20938 8.73329 5.33436C11.0674 4.4103 13.4896 3.94828 16 3.94828C18.5104 3.94828 20.9326 4.4103 23.2668 5.33436C25.477 6.20937 27.4564 7.43581 29.2049 9.01367L32 6.21865ZM26.4084 11.8103C25.048 10.6146 23.5164 9.67961 21.8134 9.00543C19.9461 8.26619 18.0083 7.89657 16 7.89657C13.9917 7.89657 12.0539 8.26619 10.1866 9.00543C8.48369 9.67961 6.95202 10.6146 5.59164 11.8103L8.39148 14.6102C9.36179 13.7943 10.4446 13.1497 11.64 12.6765C13.0405 12.1221 14.4938 11.8448 16 11.8448C17.5062 11.8448 18.9596 12.1221 20.36 12.6765C21.5553 13.1497 22.6382 13.7943 23.6086 14.6102L26.4084 11.8103ZM11.5682 17.7869L15.4858 21.7044C15.7697 21.9884 16.2303 21.9884 16.5143 21.7044L20.4319 17.7869C19.8698 17.1529 19.2025 16.6621 18.4298 16.3145C17.6572 15.967 16.8473 15.7932 16 15.7932C15.1527 15.7932 14.3429 15.967 13.5702 16.3145C12.7976 16.6621 12.1303 17.1529 11.5682 17.7869Z",
    fill: "url(#paint0_radial_103_1572)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_103_1572",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0937) rotate(90.2415) scale(22.2189 32.0003)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073FF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectivity);
export default __webpack_public_path__ + "static/media/connectivity.dbebecebb027714367a66a306703f0ed.svg";
export { ForwardRef as ReactComponent };